
import React from 'react';
import {sprintf} from "sprintf-js";
import { DEVICE_WIDTH, USER} from "../../../lib/constants";
import { InvestmentAccountType } from "../../../lib/proto/investment_accounts";
import {dollarToString, price_string_to_dollars} from "../../../lib/currency-utils";
import {Action, Info, TextLoading} from "../../funcs/utils";
import {PaymentsContainer2} from "./common";
import {dollarValidator, Text} from "../../../lib/prm/text";
import {Name} from "../../../lib/prm/name";
import {FlowRender} from "../../../lib/flow-render";
import {sendWithdrawEmail} from "./action";

const WITHDRAW_TYPE = {
  TAXABLE: "TAXABLE",
  IRA: "IRA",
  ROTH: "ROTH",
};

const WITHDRAW_STATE = {
  INIT: "INIT",
  SHOW_IRS_DIALOG: "SHOW_IRS_DIALOG",
  SHOW_LIQUIDATE_DIALOG: "SHOW_LIQUIDATE_DIALOG",
  SHOW_MOVE_MONEY_DIALOG: "SHOW_MOVE_MONEY_DIALOG",
  EXECUTE_MOVE_MONEY_SIGNING: "EXECUTE_MOVE_MONEY_SIGNING",
  SEND_WITHDRAWAL_REQUEST: "SEND_WITHDRAWAL_REQUEST",
}

const withdrawal_amt = new Text(new Name("withdrawal_amt"));
withdrawal_amt.setValidator(dollarValidator);

const ALL_PRMS = new FlowRender(0, [
  withdrawal_amt,
]);

const get_tda = component => {
  const acct_index = parseInt(component.props.acct_index, 10);
  const acct_key = sprintf("%04d", acct_index);
  return component.props.tda[acct_key];
}

const calc_withdraw_type = tda => {
  if (!tda) {
    return WITHDRAW_TYPE.TAXABLE;
  }
  const id = tda.account_type.toLowerCase();
  if (id === InvestmentAccountType.roth_ira.id) {
    return WITHDRAW_TYPE.ROTH;
  }
  if (id.includes("ira")) {
    return WITHDRAW_TYPE.IRA;
  }
  return WITHDRAW_TYPE.TAXABLE;
}

const withdrawal_card_state = component => {
  const state = {};
  ALL_PRMS.init(state, {}, component);
  state.withdraw_state = WITHDRAW_STATE.INIT;
  const tda = get_tda(component);
  state.withdraw_type = calc_withdraw_type(tda);
  state.is_sending = false;
  return state;
};

const render_item = (amt, str, amt_style_over = {}, container_style_over = {}) => {
  const amt_style = {
    width: "10rem",
    border: "1px #000 solid",
    padding: "0.5rem 0",
    fontSize: "1.2rem",
    ...amt_style_over,
  }
  const container_style = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    marginLeft: "0rem",
    ...container_style_over,
  };

  return (
    <div style={container_style}>
      <div style={amt_style} align={"center"}>
        {amt}
      </div>
      <div style={{flex: "1", paddingLeft: "1rem"}}>
        {str}
      </div>
    </div>
  )
};

const render_item_stacked = (amt, str, amt_style_over = {}, bottom = null ) => {
  const container_style = {
    width: "100%",
  }
  const amt_style = {
    width: "10rem",
    border: "1px #000 solid",
    padding: "0.5rem 0",
    fontSize: "1.2rem",
    textAlign: "center",
    ...amt_style_over
  }

  return (
    <div style={container_style}>
      <div style={{height: "3rem"}}>
        {str}
      </div>
      <div style={{height: "0.5rem"}}/>
      <div style={amt_style}>
        {amt}
      </div>
      <div style={{height: "1rem"}}/>
      <div>
        { bottom }
      </div>
    </div>
  )
}

const send_withdrawal_request = component => {
  component.setState({
    is_sending: true,
  });
  const amt_usd = price_string_to_dollars(withdrawal_amt.getValue(component.state));
  const acct_index = parseInt(component.props.acct_index, 10);
  sendWithdrawEmail(component.props.token, amt_usd, acct_index)
    .then(() => {
      component.setState({
        is_sending: false,
        request_sent: true,
      });
    })
}

const WithdrawalCard = props => {

  const component = props.component;
  const tda = get_tda(component);
  const dashboard = component.getUserDashboard();
  let cash, total, acct;

  if (component.props.user.account_type !== USER) {
    return null;
  }

  if (!dashboard) {
    cash = "N/A";
    total = "N/A";
  } else if (dashboard.balances.accts.length !== 1) {
    cash = "N/A";
    total = "N/A";
  } else if (dashboard.balances.total_value === "PENDING") {
    return null;
  } else if (tda.account_type.toLowerCase().includes("ugma")) {
    return null;
  } else {
    acct = dashboard.balances.accts[0];
    cash = dollarToString(acct.cash);
    total = dollarToString(acct.value);
  }

  const input_style = {
    width: "100%",
    textAlign: "center",
  }
  const withdraw_text = (
    <div>
      <p>Enter the amount you would like to withdraw.</p>
    </div>
  );

  const is_blank = withdrawal_amt.isBlank(component.state);
  //const withdraw_amt = price_string_to_dollars(withdrawal_amt.getValue(component.state));

  const do_small = component.props.app.width <= DEVICE_WIDTH.medium;
  const cash_item = do_small
    ? render_item_stacked(cash, "Cash available for withdrawal")
    : render_item(cash, "Cash available for withdrawal");
  const total_item = do_small
    ? render_item_stacked(total, "Total portfolio amount")
    : render_item(total, "Total portfolio amount");
  const withdraw_item = do_small
    ? render_item_stacked(
      withdrawal_amt.renderInput(component, input_style),
      "Amount requested for withdrawal",
      { border: "0" })
    : render_item(
      withdrawal_amt.renderInput(component, input_style),
      withdraw_text,
      { border: "0" });

  const info_text = "You can put in a request to withdrawal funds from your investment account here.";
  const info = (
    <Info
      id={"widthdrawals"}
      text={info_text}
      popup_style={{ width: "30rem" }}
      style={{fontSize: "1.5rem"}}
      component={component}/>);

  const action_div = component.state.request_sent
    ? (<div>Request Sent</div>)
    : (<Action disabled={is_blank} onClick={() => send_withdrawal_request(component)}>
        <TextLoading
          label={"Request Withdrawal"}
          loading={component.state.is_sending}/>
      </Action>);
  return (
    <PaymentsContainer2
      client={component.props.client}
      suffix={info}
      title={"Withdrawals"}>
      <div style={{display: "flex", flexWrap: "wrap"}}>
        <div style={{flex: "1"}}>
          { cash_item }
        </div>
        <div style={{flex: "1"}}>
          { total_item }
        </div>
      </div>
      <div style={{height: "1rem"}}/>
      <div style={{display: "flex"}}>
        <div style={{flex: "1"}}>
          { withdraw_item }
        </div>
        <div style={{flex: "1"}}/>
      </div>
      <div style={{height: "3rem"}}/>

      <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
        { action_div }
      </div>
    </PaymentsContainer2>
  )
};

export { WithdrawalCard, withdrawal_card_state };
